/* Layout */
import Layout from '@/views/layout/Layout';
export default [
  {
    path: '/doctorAssistantManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '医助管理',
      icon: 'peoples',
    },
    children: [
      {
        path: '/doctorAssistantManage/doctorList',
        component: () => import('@/myviews/AE_doctorAssistantManagement/doctorList/doctorList'),
        alwaysShow: false,
        name: '医助管理',
        meta: {
          title: '医助管理',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
    ]
  },
  {
    path: '/doctorAssistantManage',
    notShow:true,
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '医助修改',
      icon: 'peoples',
    },
    children: [
      {
        path: '/doctorAssistantManage/editDoctor',
        component: () => import('@/myviews/AE_doctorAssistantManagement/editDoctor/editDoctor'),
        alwaysShow: false,
        name: '医助修改',
        meta: {
          title: '医助修改',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/nurseManage/AE_doctorAssistantManage.js